module.exports = __webpack_public_path__ + "static/media/deadlines.860b6c8c.jpg";